// extracted by mini-css-extract-plugin
export default {"presentationCard":"Presentation_presentationCard__++xRn","ImageContainer":"Presentation_ImageContainer__nMfgO"};